export const X1DarkModeSetting = {
  initialSetting:
    localStorage.getItem("isDarkMode") === "ENABLED" ? "ENABLED" : "DISABLED",
  initialGuessForDarkModeOnClient: true,
};
